import { Component, OnInit, Inject } from '@angular/core';
import { DatabaseService } from 'src/_services/DatabaseService';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material';
import { sessionStorage } from 'src/app/localstorage.service';
import { ToastrManager } from 'ng6-toastr-notifications';
import * as moment from 'moment';
import { DialogComponent } from '../dialog.component';

@Component({
  selector: 'app-redeem-status-modal',
  templateUrl: './redeem-status-modal.component.html',
  styleUrls: ['./redeem-status-modal.component.scss']
})
export class RedeemStatusModalComponent implements OnInit {
  savingFlag: boolean = false;
  segment: any = {};
  category: any = {};
  login: any = {};
  drlist:any =[]
  delivery_from: any;
  userData: any;
  userId: any;
  userName: any;
  today_date: any;

  constructor(@Inject(MAT_DIALOG_DATA) public data, public dialog: MatDialog, public serve: DatabaseService, public session: sessionStorage, public toast: ToastrManager,public alert : DialogComponent , public dialogRef: MatDialogRef<RedeemStatusModalComponent>) {
    this.userData = JSON.parse(localStorage.getItem('st_user'));

    console.log(data)

    this.data.dealerName = this.data.firm_name;
    this.data.dealerMobile = this.data.firm_mobile;
    this.data.city = this.data.city;
    this.data.per_person = this.data.per_person;
    this.data.total_member = this.data.total_member;
    this.data.total_budget = this.data.total_budget;
    this.data.contactPerson = this.data.contact_person;
    this.data.actualAmt  = this.data.actual_expense ;
    this.today_date = new Date();
    this.segment = this.data.segment;
    this.userId = this.userData['data']['id'];
    this.userName = this.userData['data']['name'];
    this.delivery_from = this.data.delivery_from;
    this.getSalesUser('')
    this.distributorList('','');
    if(this.data.delivery_from  == 'redeem_status'){
      this.data.order_status = this.data.gift_status;
    }

  }

  ngOnInit() {
    this.login = JSON.parse(localStorage.getItem('login'));
  }
  reason_reject: any
  redeem_status_change(reason, status) {
    this.savingFlag = true;
    this.serve.post_rqst({ 'status': status, 'id': this.data.id, 'created_by_id':this.userId, 'created_by_name':this.userName, 'reject_reason': reason }, "RedeemRequest/redeemRequestStatusChange").subscribe((result => {
      if (result['statusCode'] == 200){
        this.dialogRef.close(true);
        this.savingFlag = false;
        this.toast.successToastr(result['statusMsg']);
      }
      else {
        this.toast.errorToastr(result['statusMsg']);
        this.savingFlag = false;
      }

    }))

  }


  updateNumber() {
    this.savingFlag = true;
    this.serve.post_rqst({ 'wallet_number': this.data.wallet_number, 'id': this.data.id, 'created_by_id':this.userId, 'created_by_name':this.userName}, "RedeemRequest/saveWalletNumber").subscribe((result => {
      if (result['statusCode'] == 200){
        this.dialogRef.close(true);
        this.savingFlag = false;
        this.toast.successToastr(result['statusMsg']);
      }
      else {
        this.toast.errorToastr(result['statusMsg']);
        this.savingFlag = false;
      }

    }))

  }




  salesUser:any =[];
  getSalesUser(searcValue) {
    this.serve.post_rqst({'search':searcValue}, "influencer/salesUserList").subscribe((response => {

      if (response['statusCode'] == 200) {
        this.salesUser = response['all_sales_user'];
      }
      else {
        this.toast.errorToastr(response['statusMsg']);
      }

    }));
  }
  distributorList(searcValue, state) {
    this.serve.post_rqst({'search':searcValue, 'state':state}, "influencer/distributorsList").subscribe((result => {
      if (result['statusCode'] == 200) {
        this.drlist = result['distributors'];
      }
      else {
        this.toast.errorToastr(result['statusMsg']);
      }

    }))
  }
  influencer_status_change(reason, status) {
    this.savingFlag = true;
    if(status == 'Approved'){
      this.alert.confirm('Are you sure ?').then((result) => {
        if (result) {
          this.serve.post_rqst({ 'status': status, 'influencer_id': Number(this.data.id),'welcome_bonus_flag': Number(this.data.welcome_bonus_flag), 'created_by':Number(this.userId) ,'distributor_id':this.data.distributor_id,'referred_by':this.data.referred_by_id,'name':this.data.name,'influencer_type':this.data.influencer_type}, "Influencer/influencerStatusChange").subscribe((result => {
            if (result['statusCode'] == 200) {
              this.dialogRef.close(true);
              this.savingFlag = false;
              this.toast.successToastr('Status Changed Successfully');
            }
            else {
              this.toast.errorToastr(result['statusMsg']);
              this.savingFlag = false;
            }

          }))
        }
      });
    }else{
      this.serve.post_rqst({ 'status': status, 'influencer_id': Number(this.data.id), 'welcome_bonus_flag': Number(this.data.welcome_bonus_flag), 'created_by':Number(this.userId) ,'reject_reason': reason,'referred_by':this.data.referred_by_id,'name':this.data.name,'influencer_type':this.data.influencer_type}, "Influencer/influencerStatusChange").subscribe((result => {

        if (result['statusCode'] == 200) {
          this.dialogRef.close(true);
          this.savingFlag = false;
          this.toast.successToastr('Status Changed Successfully');
        }
        else {
          this.toast.errorToastr(result['statusMsg']);
          this.savingFlag = false;
        }

      }))
    }
  }

  calculataionTotal() {
    // Make sure total_member and per_person are valid numbers
    const totalMember = this.data.total_member;
    const perPerson = this.data.per_person;

    if (totalMember && perPerson) {
      const totalBudget = totalMember * perPerson;
      this.data.total_budget = totalBudget;  // Update the total_budget value
      console.log(totalMember, perPerson, totalBudget);  // Log for debugging
    } else {
      // Handle the case where values are missing or invalid
      this.data.total_budget = 0;
    }
  }


  gift_status_change(header) {
    this.serve.post_rqst(header, 'RedeemRequest/redeemRequestGiftStatusChange').subscribe((result => {
      if (result['statusCode'] == 200){
        this.dialog.closeAll();
        this.savingFlag = false;
        this.toast.successToastr(result['statusMsg']);
      }
      else {
        this.toast.errorToastr(result['statusMsg']);
        this.savingFlag = false;
      }
    }))
  }

  updateStatus(status) {
    this.data.estimate_date = moment(this.data.estimate_date).format('YYYY-MM-DD')
    this.data.transfer_date = moment(this.data.transfer_date).format('YYYY-MM-DD')
    this.savingFlag = true;
    let header = {}
    if (status == 'Under Process' || status == 'Received') {
      header = { 'status': status, 'id': this.data.id }
      this.gift_status_change(header)
    } else if (status == 'Shipped') {

      header = { 'status': status, 'id': this.data.id, 'shipping_remark': this.data.Shipped_remark, 'shipping_type': this.data.shipping_type, 'estimate_date': this.data.estimate_date }
      this.gift_status_change(header)
    } else if (status == 'Transferred') {
      header = { 'status': status, 'id': this.data.id, 'payment_mode': this.data.transfer_mode, 'transfer_date': this.data.transfer_date, "transfer_remark": this.data.transfer_remark, 'transaction_no': this.data.transaction_number }
        this.gift_status_change(header)
      // if (this.data.transfer_mode == 'Online') {
      //   header = { 'status': status, 'id': this.data.id, 'payment_mode': this.data.transfer_mode, 'transfer_date': this.data.transfer_date, "transfer_remark": this.data.transfer_remark }
      //   this.gift_status_change(header)
      // } else if (this.data.transfer_mode == 'Online') {

      // }
    }
  }

  MobileNumber(event: any) {
    const pattern = /[0-9\+\-\ ]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) { event.preventDefault(); }
  }


  dealerDataupdateInEventPlan(status) {
    this.savingFlag = true;
      this.serve.post_rqst({ 'eventId': this.data.id,'city':this.data.city,'state':this.data.state,'total_member':this.data.total_member,'per_person':this.data.per_person,'total_budget':this.data.total_budget,'dealerName': this.data.dealerName, 'dealerMobile':Number(this.data.dealerMobile),'contactPerson':this.data.contactPerson}, "Event/updateActualDealerData").subscribe((result => {
        if (result['statusCode'] == 200) {
          this.dialog.closeAll();
          this.savingFlag = false;
          this.toast.successToastr(result['statusMsg']);
        }
        else {
          this.toast.errorToastr(result['statusMsg']);
          this.savingFlag = false;
        }
      }))
  }


  UpdateActualExpenseAmount(status) {
    this.savingFlag = true;
      this.serve.post_rqst({ 'eventId': this.data.id, 'actualAmt': this.data.actualAmt}, "Event/updateActualAmt ").subscribe((result => {
        if (result['statusCode'] == 200) {
          this.dialog.closeAll();
          this.savingFlag = false;
          this.toast.successToastr(result['statusMsg']);
        }
        else {
          this.toast.errorToastr(result['statusMsg']);
          this.savingFlag = false;
        }
      }))
  }
}
